<template>
  <span>Lilo<span class="g2">-</span>{{ suffix }}</span>
</template>

<script>
export default {
  name: 'BrandProduct',
  props: {
    kind: {
      type: String,
      required: true,
    },
  },
  computed: {
    suffix() {
      return this.kind === 'ride' ? 'Ride' : 'School'
    },
  },
}
</script>

<style scoped>
.g2 { color: #FFA800; }
</style>
